import Api from "./baseApi";
export default {
  searchInsurance: insurance => {
    let url = "/api/insurances?v=1";
    if (insurance.search) url += `&q=${insurance.search}`;
    if (insurance.state > -1) url += `&state=${insurance.state}`;
    if (insurance.categoryId > 0) url += `&categoryId=${insurance.categoryId}`;
    return Api.get(url);
  },
  getInsurances: () => Api.get("/api/insurances"),
  getInsurance: id => Api.get(`/api/insurances/${id}`),
  putInsurance: insurance => Api.put(`/api/insurances/${insurance.id}`, insurance),
  deleteInsurance: insurance => Api.delete(`/api/insurances/${insurance.id}`, insurance),
  postInsurance: insurance => Api.post(`/api/insurances`, insurance),
  buyInsurances(insurances, cb, errorCb) {
    setTimeout(() => {
      // simulate random checkout failure.
      Math.random() > 0.5 || navigator.userAgent.indexOf("PhantomJS") > -1
        ? cb()
        : errorCb();
    }, 100);
  }
}; 
